import React, { useState, useEffect } from "react";
// added css import
import "../styles/Contact.css";
import { contactInfoApi } from '../api/phpApi';

const defaultData = {
  contact: {
    phone: "+123 456 7890",
    email: "support@example.com",
    address: "123 Example St, City",
  },
  text: {
    title: "Contact",
    subtitle: "Send a message or find our location and contact details below.",
    formTitle: "Get in touch",
    formSubtitle: "We usually reply within 24 hours.",
    emailNote: "Or email us at support@example.com",
  },
};

export default function Contact() {
  const [contactData, setContactData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [status, setStatus] = useState("");

  useEffect(() => {
    fetchContactData();
  }, []);

  const fetchContactData = async () => {
    try {
      setLoading(true);
      const data = await contactInfoApi.getAll();
      if (data && data.length > 0) {
        setContactData(data);
      } else {
        // Fallback to default data
        setContactData([
          { type: 'phone', label: 'Téléphone', value: '+123 456 7890' },
          { type: 'email', label: 'Email', value: 'support@example.com' },
          { type: 'address', label: 'Localisation', value: '123 Example St, City' }
        ]);
      }
    } catch (error) {
      console.error('Failed to load contact data:', error);
      // Fallback to default data
      setContactData([
        { type: 'phone', label: 'Téléphone', value: '+123 456 7890' },
        { type: 'email', label: 'Email', value: 'support@example.com' },
        { type: 'address', label: 'Localisation', value: '123 Example St, City' }
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((s) => ({ ...s, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // basic client-side validation
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      setStatus("Please fill in all fields.");
      return;
    }
    // replace with real submit logic as needed
    console.log("Contact form submitted:", form);
    setStatus("Message sent.");
    setForm({ name: "", email: "", subject: "", message: "" });
    // clear message after a few seconds
    setTimeout(() => setStatus(""), 3500);
  };

  return (
    <section className="contact-section-contact">
      <div className="contact-container-contact">
        <div className="section-header-contact">
          <div className="section-header-v2">
        <span className="accent-line"></span>
        <h2>{defaultData.text.title}</h2>
      </div>

          <p className="section-subtitle-contact">{defaultData.text.subtitle}</p>
        </div>

        <div className="contact-content-contact">
          {/* Contact Form */}
          <div className="contact-form-wrapper-contact">
            <div className="form-header-contact">
              <h3>{defaultData.text.formTitle}</h3>
              <p>{defaultData.text.formSubtitle}</p>
            </div>

            <form onSubmit={handleSubmit} className="contact-form-contact">
              <div className="form-row-contact">
                <div className="input-group-contact">
                  <input
                    id="name"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    type="text"
                    placeholder="NOM COMPLET"
                    required
                  />
                </div>
                <div className="input-group-contact">
                  <input
                    id="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    type="email"
                    placeholder="ADRESSE EMAIL"
                    required
                  />
                </div>
              </div>

              <div className="input-group-contact">
                <input
                  id="subject"
                  name="subject"
                  value={form.subject}
                  onChange={handleChange}
                  type="text"
                  placeholder="OBJET DU MESSAGE"
                  required
                />
              </div>

              <div className="input-group-contact">
                <textarea
                  id="message"
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  rows={6}
                  placeholder="VOTRE MESSAGE..."
                  required
                />
              </div>

              <div className="form-actions-contact">
                <button type="submit" className="submit-btn-contact">
                  Evoyer Le Message
                </button>
                {status && (
                  <span className={`status-contact ${status.toLowerCase().includes("sent") ? "success" : "error"}`}>
                    {status}
                  </span>
                )}
              </div>
            </form>
          </div>

          {/* Contact Information */}
          <div className="contact-info-wrapper-contact">
            <div className="info-blocks-contact">
              {loading ? (
                <div className="loading">Chargement des informations de contact...</div>
              ) : (
                contactData.map((item, index) => (
                  <div key={index} className="info-item-contact">
                    <span className="info-label-contact">{item.label}</span>
                    <p>{item.value}</p>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

